import {
  CartEvent,
  CartManagerState,
} from "@/global/store/data/purchaseSeats/cartManager";
import { EventType } from "@/global/store/data/types";

export function findNextActiveEvent(
  activeEvent: EventType | null,
  selectedEvents: EventType[],
  forward: boolean
) {
  const currentIdx = selectedEvents.findIndex((itm) => {
    return itm.eventCode == activeEvent?.eventCode;
  });
  const newIdx = forward ? currentIdx + 1 : currentIdx - 1;
  return selectedEvents[newIdx];
}

export function findNextUnholdEvent(
  activeEvent: EventType | null,
  selectedEvents: EventType[],
  cartState?: CartManagerState
) {
  let result = null;
  if (!cartState) return result;
  selectedEvents = selectedEvents.filter((itm) => {
    return itm.eventCode !== activeEvent?.eventCode;
  });
  for (let itm of selectedEvents) {
    let cartEvent = cartState.cart.find((cart) => {
      return cart.eventCode == itm.eventCode;
    });
    if (!cartEvent || !cartEvent?.isHeld) {
      result = itm;
      break;
    }
  }
  return result;
}

export function findUnholdEventsInCart(
  selectedEvents: EventType[],
  cartState: CartManagerState
) {
  return selectedEvents.filter((evt) => {
    const helds = cartState.cart.filter((itm) => itm?.isHeld);
    return !helds.some((held) => held?.eventCode == evt?.eventCode);
  });
}

export function findEventsHeldInCart(cartState: CartManagerState) {
  return cartState?.cart.filter((evt) => evt?.isHeld);
}

export function isLastActiveEventInCart(
  event: EventType | null,
  arr: EventType[]
) {
  const idx = arr.findIndex((itm) => itm.eventCode == event?.eventCode);
  return idx == arr.length - 1;
}

export function findEventInCart(
  activeEvent: EventType | null,
  cart: CartManagerState["cart"]
) {
  return (
    cart.find((itm: any) => {
      return activeEvent?.eventCode == itm.eventCode;
    }) || null
  );
}

export function findEventByCartEvent(
  events: EventType[],
  cartEvent: CartEvent
) {
  return (
    events.find((itm) => {
      return itm.eventCode == cartEvent.eventCode;
    }) || null
  );
}

export function findEventByEventCode<T extends { eventCode: string | null }>(
  events: T[],
  eventCode: string | null
): T | null {
  if (!eventCode) return null;
  return (
    events.find((itm) => {
      return itm.eventCode == eventCode;
    }) || null
  );
}

export function findLocationsHeldInCart(cartState: CartManagerState) {
  return cartState?.cart
    .filter((itm) => itm?.isHeld && itm?.location)
    .map((itm) => itm?.location);
}

export function sortEventsByUnhold<T extends EventType>(
  selectedEvents: T[],
  unHoldEvents: T[]
) {
  const filtered = selectedEvents.filter((itm) => {
    return !unHoldEvents.some((evt) => evt.eventCode == itm.eventCode);
  });
  return [...filtered, ...unHoldEvents];
}

export function sortCartEventsBySelection(
  cartEvents: CartEvent[],
  selectedEvents: EventType[]
) {
  const sorted = [];
  for (let { eventCode: evtCode } of selectedEvents) {
    let cartEvent = cartEvents.find(({ eventCode }) => evtCode == eventCode);
    if (cartEvent) sorted.push(cartEvent);
  }
  if (sorted.length !== cartEvents.length) return cartEvents;
  return sorted;
}

export function findDiffSeats(cartEvent: CartEvent | null) {
  if (!cartEvent?.location) return [];
  return (
    cartEvent?.products?.filter((inv) => {
      const locationSection = cartEvent?.location?.split("_")[1];
      if (inv?.sectionName !== locationSection) return true;
    }) || []
  );
}

export function calcCartEventTotalSeatCount(cartEvent: CartEvent | null) {
  let res = 0;
  cartEvent?.products.forEach((inv) => {
    if (inv.seatCount !== undefined) res += Number(inv.seatCount);
  });
  return res;
}
